import { useDispatch as reactReduxUseDispatch } from 'react-redux'

function useDispatch () {
  return reactReduxUseDispatch()
}

export default useDispatch
